import { useEffect, useState } from 'react';
import { supabase } from '../supabase.js';
import { loadExpenses } from './adminData.js';

const columns = [['month', 'Per month'], ['year', 'Per year'], ['first', 'First year']];

const pounds = (value) => `£${value.toLocaleString('en-GB')}`;

function cost(row) {
  if (row.costText) return row.costText;
  if (!row.cost) return '';
  const [low, high = low] = row.cost;
  return `${row.about ? 'About ' : ''}${low === high ? pounds(low) : `${pounds(low)}–${pounds(high)}`}${row.open ? '+' : ''}${row.suffix ? ` ${row.suffix}` : ''}`;
}

/** The middle of what `rows` add up to in a column, in whole pounds. */
function middle(rows, column) {
  return Math.round(rows.filter((row) => row.cost && row.column === column)
    .reduce((sum, { cost: [low, high = low] }) => sum + (low + high) / 2, 0));
}

/**
 * The Expenses tab: what the company pays for, kept in the database (private.expenses) and changed there. Each cost shows once, in the
 * column for how often it is paid. The foot adds up each column: what we pay now, what we plan to, and both together.
 */
export default function ExpensesTab() {
  const [state, setState] = useState({ expenses: null, error: '' });

  useEffect(() => {
    let live = true;
    loadExpenses(supabase).then(
      (expenses) => { if (live) setState({ expenses, error: '' }); },
      (cause) => { if (live) setState({ expenses: null, error: cause.message || 'Could not load the expenses. Please try again.' }); },
    );
    return () => { live = false; };
  }, []);

  const { expenses, error } = state;
  if (error) return <p className="mod-error" role="alert">{error}</p>;
  if (!expenses) return <p>Loading the expenses…</p>;
  const items = Array.isArray(expenses.items) ? expenses.items : [];
  if (items.length === 0) return <p className="admin-empty">Nothing on Expenses yet.</p>;
  const foot = [
    ['Paying now', items.filter((row) => row.status === 'Paying')],
    ['Planned', items.filter((row) => row.status === 'Planned')],
    ['Total', items],
  ];
  return (
    <div className="mod-table-wrap">
      <table className="mod-audit" aria-label="What the company pays for">
        <thead><tr><th scope="col">Expense</th><th scope="col">Type</th><th scope="col">Status</th>{columns.map(([key, label]) => <th scope="col" className="revenue-cost" key={key}>{label}</th>)}</tr></thead>
        <tbody>
          {items.map((row) => (
            <tr key={row.what}>
              <td>{row.what}</td>
              <td>{row.type}</td>
              <td>{row.status}</td>
              {columns.map(([key]) => <td key={key}><span className="revenue-cost">{row.column === key ? cost(row) : ''}</span></td>)}
            </tr>
          ))}
        </tbody>
        <tfoot className="revenue-total">
          {foot.map(([label, rows]) => (
            <tr key={label}>
              <th scope="row" colSpan={3}>{label}</th>
              {columns.map(([key]) => <td key={key}>{middle(rows, key) ? pounds(middle(rows, key)) : '–'}</td>)}
            </tr>
          ))}
        </tfoot>
      </table>
    </div>
  );
}
